// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"886e521a","928":"7fcc531c"}[chunkId] + ".chunk.js";
};